export const formatNumber = (hexValue: string, decimals = 6) => {
  // Convert the hex value to a BigInt
  const valueBigInt = BigInt(hexValue);
  // Convert to a human-readable format using decimals
  const factor = BigInt(10 ** decimals);
  const formattedValue = Number(valueBigInt) / Number(factor);
  return formattedValue;
};

export const formatNumberToString = (
  num: number | string | undefined | null
) => {
  if (num === undefined || num === null) {
    return undefined;
  }
  if (typeof num === "string") {
    return parseFloat(num).toLocaleString();
  }
  return num.toLocaleString();
};
